import * as React from 'react'
import Typography from '@mui/material/Typography'
import { BulkActionErrorDetail } from '../typings'

type Props = { detail: BulkActionErrorDetail }

export const BulkActionErrorDescription: React.FC<Props> = ({
  detail: { name, description, note },
}) => (
  <>
    <Typography color="error" gutterBottom>
      {name}
    </Typography>
    <Typography paragraph>{description}</Typography>
    {note && (
      <ul style={{ marginBottom: '0px' }}>
        <li>
          <Typography paragraph>{note}</Typography>
        </li>
      </ul>
    )}
  </>
)
BulkActionErrorDescription.displayName = 'BulkActionErrorDescription'
